// frontend/src/mobile/InvoiceCard.jsx
import { Badge } from "@/components/ui/badge";
import { formatCurrency, formatCurrencyIn, formatDateShort } from "@/utils/format";
import { invoiceStatusMeta, installmentLine } from "@/utils/invoiceStatus";
import { formatInvoiceLabel } from "@/utils/invoiceFormat";

const LINE_TONE = { rose: "text-rose-600", amber: "text-amber-700" };

export default function InvoiceCard({ inv, kind, onTap }) {
  const meta = invoiceStatusMeta(inv, kind);
  const plazos = kind === "emitted" ? installmentLine(inv) : null;
  const isForeign = (inv.currency ?? "EUR") !== "EUR";
  const total = isForeign && inv.total_amount_eur == null
    ? formatCurrencyIn(inv.total_amount, inv.currency)
    : formatCurrency(inv.total_amount_eur ?? inv.total_amount);
  return (
    <button
      data-testid={`minv-card-${inv.invoice_id}`}
      onClick={() => onTap(inv)}
      className="w-full text-left bg-white border border-slate-200 rounded-2xl px-3.5 py-3 min-h-[44px]"
    >
      <div className="flex items-start justify-between gap-3">
        <p className="flex-1 min-w-0 truncate text-sm font-medium text-slate-900 leading-snug">
          {kind === "emitted" ? inv.client_name : inv.supplier_name}
        </p>
        <p className="font-mono text-[15px] font-semibold tabular-nums whitespace-nowrap text-slate-900">
          {total}
        </p>
      </div>
      <div className="mt-1.5 flex items-center gap-2 min-w-0">
        {kind === "emitted" && (
          <span className="font-mono text-[11px] text-slate-500 whitespace-nowrap">{formatInvoiceLabel(inv.series, inv.invoice_number)}</span>
        )}
        <span className="font-mono text-[11px] text-slate-400 whitespace-nowrap">{formatDateShort(inv.invoice_date)}</span>
        {kind === "received" && (
          <span className="flex-1 min-w-0 truncate text-[11px] text-slate-500">{inv.category ?? ""}</span>
        )}
        <Badge variant="secondary" className={`ml-auto whitespace-nowrap ${meta.cls}`}>{meta.label}</Badge>
      </div>
      {isForeign && inv.total_amount_eur == null && (
        <p className="mt-1.5 text-[11px] text-amber-700">EUR real pendiente de conciliación</p>
      )}
      {meta.line && <p className={`mt-1.5 text-[11px] font-semibold ${LINE_TONE[meta.lineTone] ?? "text-slate-500"}`}>{meta.line}</p>}
      {plazos && <p className="mt-1 text-[11px] text-slate-500">{plazos}</p>}
    </button>
  );
}
